import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {UrlPrefixes} from 'src/app/model/cms-btv-core/config-controller/config-url-prefix.model';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlPrefixesService {
  readonly btvPrevixApi = environment.endPoint + ApplicationPackage.CMS_BTV + Service.ATLAS_CONFIG;
  readonly contentUrlPrefixes = environment.endPoint + ApplicationPackage.CMS_VOD + Service.ATLAS_CONFIG;
  constructor(private http: HttpClient) {}

  getBtvPrefixes(): Observable<UrlPrefixes[]> {
    return this.http.get<UrlPrefixes[]>(this.btvPrevixApi + '/urlprefixes');
  }
  getContentUrlPrefixes(): Observable<UrlPrefixes[]> {
    return this.http.get<UrlPrefixes[]>(this.contentUrlPrefixes + '/urlprefixes');
  }
}
